import { getApiBase } from '../env';

export const ImageUrl = (url: string) => `${getApiBase()}${url}`